var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-connect" },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v("Allow Authorization"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _vm.showBackBtn
                ? _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.back.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Back")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-primary",
                  attrs: { type: "button", disabled: !_vm.isValid },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.ok(_vm.datasource)
                    },
                  },
                },
                [_vm._v("Submit")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "go-form-connect-mode" }, [
        _c("div", { staticClass: "go-form-header" }, [
          _c("div", { staticClass: "go-brand" }, [
            _c("div", { staticClass: "go-brand-symbol" }, [
              _c("img", {
                attrs: { src: _vm.channelImageUri, alt: _vm.channelName },
              }),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.channelName))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-form-body" },
          _vm._l(_vm.datasource, function (item, index) {
            return _c("channel-datasource-field", {
              key: index,
              attrs: {
                value: item.value,
                type: item.type,
                disabled: item.disabled,
                multiple: item.multiple,
              },
              on: {
                change: function (value) {
                  item.value = value
                  _vm.validateForm()
                },
                "everything:update": function (status) {
                  _vm.datasource
                    .filter(function (el) {
                      return el.type === "DATA_TYPE"
                    })
                    .forEach(function (el) {
                      el.value = []
                      el.disabled = status
                    })
                  _vm.validateForm()
                  _vm.$forceUpdate()
                },
              },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }